import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import orderStatusValidator from 'reducers/work-order/close-step-validation/orderStatusValidator';
import closeCommentValidator from 'reducers/work-order/close-step-validation/closeCommentValidator';
import closeCodeValidator from 'reducers/work-order/close-step-validation/closeCodeValidator';
import pmTicketValidator from 'reducers/work-order/close-step-validation/pmTicketValidator';
import sqcValidator from 'reducers/work-order/close-step-validation/sqcValidator';
import chargesValidator from 'reducers/work-order/close-step-validation/chargesValidator';
import truckRollValidator from './close-step-validation/truckRollValidator';
import insideHomeAccessValidator from './close-step-validation/insideHomeAccessValidator';
import fstSignalsValidator from "./close-step-validation/fstSignalsValidator";
import deliveryProofValidator from "./close-step-validation/deliveryProofValidator";
import noAccessReasonValidator from "./close-step-validation/noAccessReasonValidator";
import outletOptimizationValidator from "./close-step-validation/outletOptimizationValidator";
import dropBuryValidator from './close-step-validation/dropBuryValidator';

export const setCloseStepValidation = (state, orderId) => {

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], initialStepValidation);
  
  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], orderStatusValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], closeCommentValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], closeCodeValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], insideHomeAccessValidator(state, orderId));

  //must do sqc before pm tickets
  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], sqcValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], pmTicketValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], fstSignalsValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], chargesValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], truckRollValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], dropBuryValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], outletOptimizationValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], deliveryProofValidator(state, orderId));

  state = state.setIn([
    'workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'
  ], noAccessReasonValidator(state, orderId));

  const validationList = state
    .getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation'])
    .toList();

  let isReadyToClose = true;

  validationList.forEach((item) => {
    if (!item.get('isValid')) {
      isReadyToClose = false;
    }
  });

  state = state.setIn([
    'workOrderDetails',
    orderId,
    'orderClose',
    'details',
    'stepValidation',
    'isReadyToClose'
  ], isReadyToClose);

  return state;

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/closeStepValidation.js